import React from "react";
import { InformationCircleIcon } from "@heroicons/react/outline";

/**
 * Compact, keyboard-accessible help text for dense dashboard interfaces.
 * The button keeps the explanation available without competing with the
 * primary content, while the aria-label and title preserve a useful fallback
 * for assistive technology and touch users.
 */
const InfoTooltip = ({ label, children, className = "" }) => (
  <span className={`group relative inline-flex shrink-0 align-middle ${className}`}>
    <button
      type="button"
      aria-label={label}
      title={label}
      className="inline-flex h-5 w-5 items-center justify-center rounded-full text-slate-400 transition hover:bg-slate-100 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-200"
    >
      <InformationCircleIcon className="h-5 w-5" aria-hidden="true" />
    </button>
    <span
      role="tooltip"
      className="pointer-events-none absolute right-0 top-full z-30 mt-2 hidden w-64 rounded-lg border border-slate-200 bg-slate-900 px-3 py-2 text-left text-xs font-medium leading-5 text-white shadow-xl group-hover:block group-focus-within:block"
    >
      {children}
    </span>
  </span>
);

export default InfoTooltip;
